'use client';

import {type FC} from 'react';
import clsx from 'clsx';

import {usePrefersReducedMotion} from '@/modules/foundation/hooks/usePrefersReducedMotion';

interface Props {
	videoId: string;
	title: string;
}

export const VideoPlayerBackground: FC<Props> = ({videoId}: Props) => {
	const hasReducedMotionPreference = usePrefersReducedMotion();

	let videoParams =
		'autoplay=1&loop=1&autopause=0&title=0&byline=0&portrait=0&controls=0&muted=1&background=1';

	if (hasReducedMotionPreference) {
		videoParams =
			'autoplay=0&loop=0&autopause=1&title=0&byline=0&portrait=0&controls=0&muted=1&background=1';
	}

	return (
		<div className={clsx('absolute', 'inset-0', 'overflow-hidden')}>
			<div className={clsx('relative', 'w-screen', 'h-screen', 'overflow-hidden', 'z-[-1]')}>
				<iframe
					aria-hidden="true"
					name="vimeo-player"
					title="vimeo-player"
					src={`https://player.vimeo.com/video/${videoId}?${videoParams}`}
					allow="autoplay; muted;"
					className={clsx(
						'absolute',
						'top-[47%]',
						'left-1/2',
						'-translate-x-1/2',
						'-translate-y-1/2',
						'w-screen',
						'h-screen',
						'video-bg',
					)}
				></iframe>
			</div>
		</div>
	);
};

export const VideoPlayer: FC<Props> = ({videoId, title}: Props) => {
	const videoParams = '&autopause=0&title=0&byline=0&portrait=0&controls=1';

	return (
		<div className="relative size-full overflow-hidden">
			<iframe
				name="vimeo-player"
				title={title ?? 'vimeo-player'}
				src={`https://player.vimeo.com/video/${videoId}?${videoParams}`}
				allow="fullscreen;"
				className="absolute inset-0 size-full"
			></iframe>
		</div>
	);
};
